import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PaginationComponent } from 'src/app/components/elements/pagination/pagination.component';
import { AffiliateEventResponse, AffiliateRequest, AffiliateResponse, SchemaPointResponse } from 'src/app/models/affiliate.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AffiliateService } from 'src/app/services/affiliate.service';

@Component({
  selector: 'app-affiliates-admin',
  templateUrl: './affiliates-admin.component.html',
  styleUrls: ['./affiliates-admin.component.scss']
})
export class AffiliatesAdminComponent implements OnInit {
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };
  paginationEvents = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };
  affiliates: AffiliateResponse[] = [];
  schemas: SchemaPointResponse = null;
  events: AffiliateEventResponse[] = [];
  converting: { [key: number]: boolean } = {};
  updatingEvent: { [key: number]: boolean } = {};
  updatingSchema: boolean = false;
  filterAffiliate = "";
  selected = 'affiliate';
  isCreatingAffiliate = false;
  affiliateEditing: AffiliateRequest = new AffiliateRequest();
  modalAffiliateShowing = false;
  modalSchemaShowing = false;
  modalEventShowing = false;

  constructor(
    private toastService: ToastrService,
    private affiliateService: AffiliateService
  ) {

  }

  ngOnInit(): void {
    this.getAffiliates();
    this.getSchemaPoints();
    this.getEvents();
  }

  getAffiliates() {
    this.affiliateService.getAffiliates().subscribe({
      next: (response: ResponseObject) => {
        this.affiliates = response.data as AffiliateResponse[];
        this.pagination.total = this.affiliates;
        this.resetPagination(this.pagination);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  filterAffiliates() {
    this.pagination.total = this.affiliates.filter((affiliate) => {
      return affiliate.code.includes(this.filterAffiliate) || affiliate.nit.includes(this.filterAffiliate) || affiliate.nombre.toLowerCase().includes(this.filterAffiliate.toLowerCase());
    });
    this.resetPagination(this.pagination);
  }

  createAffiliate() {
    this.isCreatingAffiliate = true;
    this.affiliateEditing = new AffiliateRequest();
    this.modalAffiliateShowing = true;
  }

  close(changed) {
    if (changed) {
      this.getAffiliates();
    }
    this.modalAffiliateShowing = false;
    this.affiliateEditing = new AffiliateRequest();
    this.isCreatingAffiliate = true;
  }

  updateSchemaStatus() {
    if (this.updatingSchema) {
      return;
    }
    this.updatingSchema = true;
    this.affiliateService.updateSchemaPoint().subscribe({
      next: (response: ResponseObject) => {
        this.updatingSchema = false;
        this.schemas.active = !this.schemas.active;
        this.toastService.success(this.schemas.active ? "Esquema activado" : "Esquema desactivado");
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getSchemaPoints() {
    this.affiliateService.getSchemaPoints().subscribe({
      next: (response: ResponseObject) => {
        this.schemas = response.data as SchemaPointResponse;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getEvents() {
    this.affiliateService.getEvents().subscribe({
      next: (response: ResponseObject) => {
        this.events = response.data as AffiliateEventResponse[];
        this.paginationEvents.total = this.events;
        this.resetPagination(this.paginationEvents);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  convert(affiliate: AffiliateResponse) {
    if (this.converting[affiliate.id]) {
      return;
    }
    this.converting[affiliate.id] = true;
    this.affiliateService.disposeAffiliate(affiliate.id, affiliate).subscribe({
      next: (response: ResponseObject) => {
        affiliate.active = !affiliate.active;
        this.converting[affiliate.id] = false;
        this.toastService.success(affiliate.active ? 'Afiliado activado' : 'Afiliado desactivado');
      },
      error: (error: HttpErrorResponse) => {
        this.converting[affiliate.id] = false;
        this.toastService.error(error.error.message);
      }
    });
  }

  updateEvent(event: AffiliateEventResponse) {
    if (this.updatingEvent[event.id]) {
      return;
    }
    this.updatingEvent[event.id] = true;
    this.affiliateService.desactiveEvent(event.id).subscribe({
      next: (response: ResponseObject) => {
        event.active = !event.active;
        this.updatingEvent[event.id] = false;
        this.toastService.success(event.active ? 'Evento activado' : 'Evento desactivado');
      },
      error: (error: HttpErrorResponse) => {
        this.updatingEvent[event.id] = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  edit(affiliate: AffiliateResponse) {
    var temp = new AffiliateRequest();
    temp['id'] = affiliate.id;
    temp.celular = affiliate.celular;
    temp.direccion = affiliate.direccion;
    temp.dpi = affiliate.dpi;
    temp.foto = null;
    temp.mail = affiliate.mail;
    temp.nacimiento = new Date(affiliate.nacimiento).toISOString().split("T")[0];
    temp.nit = affiliate.nit;
    temp.nombre = affiliate.nombre;
    this.isCreatingAffiliate = false;
    this.affiliateEditing = temp;
    this.modalAffiliateShowing = true;
  }

  closeModalSchema(created: boolean) {
    if (created) {
      this.getSchemaPoints();
    }
    this.modalSchemaShowing = false;
  }

  closeModalEvent(created: boolean) {
    if (created) {
      this.getEvents();
    }
    this.modalEventShowing = false;
  }

  resetPagination(paginationTemp) {
    paginationTemp.startElement = 0;
    paginationTemp.pageIndex = 0;
    paginationTemp.lastElement = paginationTemp.pageSize;
    paginationTemp.filter = paginationTemp.total.slice(paginationTemp.startElement, paginationTemp.lastElement);
    paginationTemp.lastElement = paginationTemp.filter.length;
  }
}
